import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import { useState } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorPartnerAddModal } from "~/components/specifics/vendors/settings/vendor_partners/VendorPartnerAddModal";
import { VendorPartnerList } from "~/components/specifics/vendors/settings/vendor_partners/VendorPartnerList";
import type { VendorPartner } from "~/models/VendorPartner";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

type Props = DeepReadonly<{
	vendorPartners: VendorPartner[];
}>;

export function Page({ vendorPartners }: Props) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<VendorSettingLayout>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: PATH, label: "設定一覧" },
						{ label: "協力会社" }
					]}
				/>
			</div>
			<Panel>
				<PanelHeader
					rightArea={
						<Button
							onClick={() => {
								setIsModalOpen(true);
							}}
							variant="primary"
						>
							追加
						</Button>
					}
					title="協力会社"
				/>
				<PanelBody>
					<VendorPartnerList vendorPartners={vendorPartners} />
				</PanelBody>
			</Panel>
			{isModalOpen ? (
				<VendorPartnerAddModal
					handleClose={() => {
						setIsModalOpen(false);
					}}
				/>
			) : null}
		</VendorSettingLayout>
	);
}
